import { target } from "@github/catalyst";
import { controller } from "./controller";

@controller
export default class XaHideRowElement extends HTMLElement {
  @target panel: HTMLElement | undefined;

  connectedCallback(): void {
    setTimeout(() => {
      this.init();
    }, 0);
  }
  init(): void {
    if (this.panel) {
      const className: string | null = this.panel.getAttribute("data-class-to-hide");
      if (className) {
        const hasDiv: HTMLElement | null = this.querySelector(`.${className}`);
        if (
          hasDiv &&
          (hasDiv.textContent?.trim() === "" ||
            hasDiv.textContent?.trim() === "N/A" ||
            hasDiv.textContent?.trim() === "YES")
        ) {
          this.parentElement?.remove();
        }
      }
    }
  }
}

declare global {
  interface Window {
    XaHideRowElement: typeof XaHideRowElement;
  }
  interface HTMLElementTagNameMap {
    "hide-row": XaHideRowElement;
  }
}

if (!window.customElements.get("hide-row")) {
  window.XaHideRowElement = XaHideRowElement;
  window.customElements.define("hide-row", XaHideRowElement);
}
